/* 
Enrutado de la aplicación, path posibles
*/

import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
//import { MemoryRouter } from 'react-router';

//REDUX
import { useDispatch, useSelector } from "react-redux";
import { checkIsSessionAction } from "./redux/actions/userActions";

//MODULES
import Header from "./modules/Header";
import Footer from "./modules/Footer";

//PAGES
import Main from "./pages/Main";
import Home from "./pages/Home";
import ListMovements from "./pages/ListMovements";
import ListGift from "./pages/ListGift";
import Profile from "./pages/Profile";
import FrequentQuestion from "./pages/FrequentQuestion";
//LoginAndRegister
//import Login from "./pages/loginAndRegister/Login";
import Register from "./pages/loginAndRegister/Register";
import Registered from "./pages/loginAndRegister/Registered";
import EmailConfirmed from "./pages/loginAndRegister/EmailConfirmed";
import EmailModified from "./pages/loginAndRegister/EmailModified";
import RestorePassword from "./pages/loginAndRegister/RestorePassword";
//Footer
import PrivacyPolicy from "./pages/footer/PrivacyPolicy";
import CookiesPolicy from "./pages/footer/CookiesPolicy";
import LegalWarning from "./pages/footer/LegalWarning";
import LegalClub from "./pages/footer/LegalClub";

//import Example from "./pages/Example";

//COMPONENTS
import PrivateRoute from "./components/utils/PrivateRoute";
import PublicRoute from "./components/utils/PublicRoute";
import Loading from "./components/utils/Loading";

//I18N
import LangSelector from "./i18n/LangSelector";
import TranslationService from "./i18n/TranslationService";
import { getModulesForRoute } from "./i18n/langUtils";
import translateDOM from "./i18n/translateDOM";

function RouteTranslationWatcher() {
  const location = useLocation();

  useEffect(() => {
    const ts = TranslationService.getInstance();
    const lang = ts.getLang();
    const needed = getModulesForRoute(location.pathname);
    ts.addModules(lang, needed).then(() => {
      setTimeout(() => translateDOM(), 0);
    });
  }, [location.pathname]);

  return null;
}

export default function Routes() {
  //#region DISPATCH & SELECTOR
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  //#endregion

  useEffect(() => {
    dispatch(checkIsSessionAction());
  }, [dispatch]);

  return (
    <Router>
      <RouteTranslationWatcher />
      {!user || !user.isLogged ? (
        <div style={{ position: 'fixed', top: 12, right: 24, zIndex: 9999 }}>
          <LangSelector />
        </div>
      ) : null}
      <Header />
      <Switch>
        <Route exact path="/frequent-question" component={FrequentQuestion} />
        {/* FOOTER */}
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/cookies-policy" component={CookiesPolicy} />
        <Route exact path="/legal-warning" component={LegalWarning} />
        <Route exact path="/legal-club" component={LegalClub} />

        <Route exact path="/login" component={Main} />
        <PublicRoute exact path="/registrar" component={Register} />
        <PublicRoute exact path="/registrado/:mail" component={Registered} />
        <PublicRoute exact path="/restore-password/:userId/:oldPassword/:mail" component={RestorePassword} />
        <PublicRoute exact path="/email-confirmado/:userId/:reConfirm/:mail" component={EmailConfirmed} />
        <PublicRoute exact path="/email-modificado/:mail" component={EmailModified} />

        <Route exact path="/" component={Main} />
        <Route exact path="/:mail" component={Main} />

        {/* HOME */}
        <PrivateRoute exact path="/home" component={Home} />
        <PrivateRoute exact path="/home/list-movements" component={ListMovements} />
        <PrivateRoute exact path="/home/list-gift" component={ListGift} />
        <PrivateRoute exact path="/home/profile" component={Profile} />
        <PrivateRoute exact path="/home/frequent-question" component={FrequentQuestion} />

       {/*  <Route exact path="/e" component={Example} /> */}
      </Switch>
      <Footer />
      <Loading />
    </Router>
  );
}
